import { ModelBase } from 'store/model-base';

export class CmsNowLines extends ModelBase {
    public static storeName: string = 'cmsNowLines';
    public header: string;
    public subHeader: string;
    public addButton: string;
    public displayNameHeader: string;
    public noLinesFound: string;
    public lines: NowLineDetails[];
    public nickNameInfo: CmsNowNickname;
    public moreOptions: CmsMoreOptions;
    public addOns: CmsAddOns;
    public dataUsageDetails: CmsDataUsageDetails;
    public paymentSummary: CmsNowPaymentSummary;
    public autoRenew: CmsAutoRenewDetails;
    public notificationBanner: CmsNowNotificationBannerInfo;
    public maxLineError: CmsNowErrorModal;
    public nonNowLanding: CmsNonNowLanding;
    public portOut: CmsNowPortOutTransferDetails;
}
